import {useModule as useModuleOriginal} from '@/store/kysely_module';

export const useModule = useModuleOriginal;
